import React, { useState } from "react";
import { apiPost } from "../../../services/api";

interface Supplier {
  id: number;
  name: string;
}

interface AddBillModalProps {
  suppliers: Supplier[];
  onClose: () => void;
  onSaved: () => void;
}

export default function AddBillModal({ suppliers, onClose, onSaved }: AddBillModalProps) {
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    supplier_id: "",
    invoice_no: "",
    total: "",
    date: new Date().toISOString().slice(0, 10),
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.supplier_id) {
      alert("Please select a supplier");
      return;
    }
    const total = Number(form.total);
    if (!Number.isFinite(total) || total <= 0) {
      alert("Please enter a valid total amount");
      return;
    }

    setSaving(true);
    try {
      await apiPost("/api/manager/purchases", {
        supplier_id: Number(form.supplier_id),
        total,
        invoice_no: form.invoice_no.trim() || null,
        date: form.date || null,
      });
      alert("✅ Supplier bill saved");
      onSaved();
    } catch (err) {
      console.error("Failed to save supplier bill", err);
      alert("❌ Failed to save supplier bill");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <form className="modal-card" onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
        <h3>🧾 Add Supplier Bill</h3>

        <div className="form-group">
          <label>Supplier *</label>
          <select
            required
            value={form.supplier_id}
            onChange={(e) => setForm((prev) => ({ ...prev, supplier_id: e.target.value }))}
            disabled={saving}
          >
            <option value="">-- Select Supplier --</option>
            {suppliers.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-row">
          <div className="form-group" style={{ flex: 1 }}>
            <label>Date *</label>
            <input
              type="date"
              required
              value={form.date}
              onChange={(e) => setForm((prev) => ({ ...prev, date: e.target.value }))}
              disabled={saving}
            />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Invoice No</label>
            <input
              value={form.invoice_no}
              onChange={(e) => setForm((prev) => ({ ...prev, invoice_no: e.target.value }))}
              placeholder="Optional"
              disabled={saving}
            />
          </div>
        </div>

        <div className="form-group">
          <label>Total Amount (₹) *</label>
          <input
            type="number"
            required
            min="0.01"
            step="0.01"
            value={form.total}
            onChange={(e) => setForm((prev) => ({ ...prev, total: e.target.value }))}
            placeholder="0.00"
            disabled={saving}
          />
        </div>

        <div className="modal-actions">
          <button type="button" className="btn-text" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button type="submit" className="btn-primary" disabled={saving}>
            {saving ? "Saving..." : "Save Bill"}
          </button>
        </div>
      </form>
    </div>
  );
}

